
import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const OperationPage = lazy(() => import('../pages/operation/page'));
const RankingPage = lazy(() => import('../pages/ranking/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/operation',
    element: <OperationPage />,
  },
  {
    path: '/ranking',
    element: <RankingPage />,
  },
];

export default routes;
